import React, { useState, useEffect } from "react";

const sexOptions = [
  "Male",
  "Female",
];

const SexQuestion = ({ onSubmit, onNext, initialValue }) => {
  const [selectedSex, setSelectedSex] = useState("");

  // Set initial value when editing
  useEffect(() => {
    if (initialValue) {
      setSelectedSex(initialValue);
    }
  }, [initialValue]);

  const handleSexChange = (sex) => {
    setSelectedSex(sex);
    // Don't call onSubmit here - only when Continue is clicked
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedSex) return;

    onSubmit(selectedSex);
    onNext();

    // Reset selection
    setSelectedSex("");
  };

  const canSubmit = selectedSex !== "";

  return (
    <form onSubmit={handleSubmit} className="input-form">
      <div className="sex-options-container">
        <div className="sex-options">
          {sexOptions.map((option) => (
            <button
              key={option}
              type="button"
              className={`sex-button ${selectedSex === option ? 'sex-button-selected' : ''}`}
              onClick={() => handleSexChange(option)}
            >
              {option}
            </button>
          ))}
        </div>
        <button
          type="submit"
          className="sex-submit-button"
          disabled={!canSubmit}
        >
          Continue
        </button>
      </div>
    </form>
  );
};

export default SexQuestion;
